export const isHippaAccount = ()=>{
    const meta = window.localStorage.getItem('accountMeta');
    if (!meta) {
        return false;
    }
    try {
        const { features } = JSON.parse(meta);
        return (features === null || features === void 0 ? void 0 : features.hippaCompliance) === true;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
        return false;
    }
};
